import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiMfaValidatemfaMutationRequest,
  PostApiMfaValidatemfaMutationResponse,
  PostApiMfaValidatemfa401,
  PostApiMfaValidatemfa403,
} from "../../../types/PostApiMfaValidatemfa";

export function getPostApiMfaValidatemfaUrl() {
  return `/api/MFA/ValidateMFA` as const;
}

/**
 * {@link /api/MFA/ValidateMFA}
 */
export async function postApiMfaValidatemfa(
  data?: PostApiMfaValidatemfaMutationRequest,
  config: Partial<RequestConfig<PostApiMfaValidatemfaMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiMfaValidatemfaMutationResponse,
    ResponseErrorConfig<PostApiMfaValidatemfa401 | PostApiMfaValidatemfa403>,
    PostApiMfaValidatemfaMutationRequest
  >({
    method: "POST",
    url: getPostApiMfaValidatemfaUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
